module.exports = __webpack_public_path__ + "images/emoji/sushi.2ed7563bb76dc59144b1.png";